//Неконтрольована форма-значення полів форми потрібні лише в момент її відправки (function-login)
import css from "./LoginForm.module.css";

import { useLanguage } from "../LanguageProvider/LanguageProvider";

// import { useLanguage } from "../LanguageContext";
export default function LoginForm() {
  const { language } = useLanguage();
  const translations = {
    en: {
      greeting: "Login",
    },
    uk: {
      greeting: "Логін",
    },
  };
  const handleSubmit = evt => {
    evt.preventDefault();

    const form = evt.target;
    const { login, password } = form.elements;

    // Посилання на DOM-елементи
    console.log(login, password);

    // Значення полів
    console.log(login.value, password.value);

    // Скидаємо значення полів після відправки
    form.reset();
  };

  return (
    <div className={css.item}>
      <form onSubmit={handleSubmit}>
        {/* <p>FORM-1-"Лише для відправки 1 раз при логіні"</p> */}
        <input className={css.ite} type="text" name="login" />
        <input className={css.ite} type="password" name="password" />
        <button className={css.btn} type="submit">
          {translations[language]?.greeting}
        </button>
      </form>
    </div>
  );
}

// export default function LoginForm3() {
//     const loginId = useId();
//     const passwordId = useId();

//     return (
//         <form>
//             <label htmlFor={loginId}>Login</label>
//             <input type="text" name="login" id={loginId} />

//             <label htmlFor={passwordId}>Password</label>
//             <input type="password" name="password" id={passwordId} />

//             <button type="submit">Login</button>
//         </form>
//     );
// };

// import React from 'react';
// import { useLanguage } from './LanguageContext';

// const TranslatedComponent = () => {
//   const { language } = useLanguage();

//   const translations = {
//     en: { welcome: "Welcome to our app!" },
//     uk: { welcome: "Ласкаво просимо до нашого застосунку!" },
//   };

//   return <p>{translations[language]?.welcome}</p>;
// };

// export default TranslatedComponent;
